/**
 * A tiny deterministic hash — the same guest always gets the same character,
 * the same string always gets the same pick, no `Math.random()` involved.
 */
export function hashString(value: string): number {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) >>> 0;
  }
  return hash;
}

/** Picks one of `options` deterministically from a hash produced by `hashString`. */
export function pickSeeded<T>(seed: number, options: readonly T[]): T {
  const value = options[seed % options.length];
  if (value === undefined) {
    throw new Error('pickSeeded requires a non-empty options array');
  }
  return value;
}
